module.exports = __webpack_public_path__ + "static/img/topo.6ab5610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/topo.png
// module id = BWq1
// module chunks = 0